//live test server on digitalocean
// export const ROOT_URL = "https://test-live.datadashbd.com/api";

//live server
export const ROOT_URL = "https://app.datadashbd.com/api";

//local server Rockey
// export const ROOT_URL = "http://datadash-backend.test/api";

export default {
  rootUrl: ROOT_URL,
};
